"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hub = exports.getIDScope = exports.IDScope = exports.Environment = exports.DataRegions = exports.MacroRegion = exports.MacroRegionName = exports.MacroRegionCode = void 0;
const effect_1 = require("effect");
exports.MacroRegionCode = effect_1.Schema.Literal('eu', 'us').annotations({
    identifier: 'Azure.MacroRegionCode',
    description: 'The physical macro regions where Azure resources are located',
});
exports.MacroRegionName = effect_1.Schema.String.annotations({
    identifier: 'Azure.MacroRegionName',
    description: 'The logical name of the Azure platform region',
});
exports.MacroRegion = effect_1.Schema.Struct({
    code: exports.MacroRegionCode,
    name: exports.MacroRegionName,
}).annotations({
    identifier: 'Azure.MacroRegion',
    description: 'The Azure platform region',
});
exports.DataRegions = effect_1.Schema.Array(exports.MacroRegionCode).annotations({
    identifier: 'Azure.DataRegions',
    description: 'The list of Azure.MacroRegion',
});
exports.Environment = effect_1.Schema.Enums({
    Development: 'dev',
    QA: 'qa',
    Test: 'test',
    Production: '',
}).annotations({
    identifier: 'Azure.Environment',
    description: 'A supported Azure environment',
    pretty: () => effect_1.Match.type().pipe(effect_1.Match.when(exports.Environment.enums.Development, () => 'Development'), effect_1.Match.when(exports.Environment.enums.QA, () => 'Quality Assurance'), effect_1.Match.when(exports.Environment.enums.Test, () => 'Testing'), effect_1.Match.when(exports.Environment.enums.Production, () => 'Production'), effect_1.Match.exhaustive),
});
exports.IDScope = effect_1.Schema.Enums({
    [exports.Environment.enums.Development]: '0ne008C12DE',
    [exports.Environment.enums.Test]: '0ne008C19D2',
    [exports.Environment.enums.QA]: '0ne00C248DF',
    [exports.Environment.enums.Production]: '0ne008C5965',
}).annotations({
    identifier: 'Azure.IDScope',
    description: 'Azure-Environment-specific string that is needed when registering a device through Azure Device Provisioning Service (DPS)',
});
const getIDScope = (environment) => exports.IDScope.enums[environment];
exports.getIDScope = getIDScope;
exports.Hub = effect_1.Schema.String.annotations({
    identifier: 'Azure.Hub',
    description: 'Hub that is returned when registering a device through Azure Device Provisioning Service (DPS)',
    examples: ['iot-northeurope-hub-main-dev-eu.azure-devices.net'],
});
//# sourceMappingURL=azure.js.map